
import React from 'react';

import  Modelpresentation2024  from 'views/Modelpresentation2024';
const MiddleSchoolPage = () => {
  return <Modelpresentation2024/>;
};

export default MiddleSchoolPage;